<template>
  <div class="container container-global">
    <div class="title">
      <h2>Algorithme de prescription</h2>
    </div>
    <div class="cadre-container">
      <div v-if="algoFirst === false && algoFourth === false" class="cadre">
        <a @click="toggleButton1()" class="title">
          <p>Prescription de contraception</p>
          <div class="next"><img :src="Right" alt="" /><img alt="" /></div>
        </a>
      </div>
      <div v-if="algoFirst === false && algoFourth === false" class="cadre">
        <a @click="toggleButton2()" class="title">
          <p>Prescription de contraception d'urgence</p>
          <div class="next"><img :src="Right" alt="" /><img alt="" /></div>
        </a>
      </div>
    </div>
    <!-- <button
      @click="goBack($route.path)"
      class="btn-big"
      v-if="algoFirst === false && algoFourth === false"
    >
      Retour
    </button> -->
    <div v-if="algoFirst">
      <Algo123 />
    </div>
    <div v-if="algoFourth">
      <Algo4 />
    </div>
  </div>
</template>

<script>
import Algo123 from "@/components/AlgoPresc123.vue";
import Algo4 from "@/components/Algo4.vue";
import Right from "@/assets/images/ArrowRight.png";
export default {
  name: "AlgoView",
  data() {
    return {
      algoFirst: false,
      algoFourth: false,
      Right,
    };
  },
  components: {
    Algo123,
    Algo4,
  },
  methods: {
    goBack(url) {
      const temp = url.split("/");
      temp.splice(temp.length - 1, 1);
      if (temp.length > 1) {
        // means current level is deeper than the first level
        this.$router.push(`${temp.join("/")}`); // redirect to previous level
      } // means previous level is home
      else {
        this.$router.push("/"); // redirect to home
        this.resetArrow();
      }
    },
    toggleButton1() {
      this.algoFirst = !this.algoFirst;
    },
    toggleButton2() {
      this.algoFourth = !this.algoFourth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";
.container {
  margin-top: 37px;
  .title {
    text-align: left;
    cursor: pointer;
  }
  .buttons {
    margin-top: 50px;
    display: flex;
    justify-content: space-around;
    .btn {
      position: relative;
      font-size: 12px !important;
      width: 40%;
      text-align: center;
      margin: 0 auto;
      padding: 16px !important;
      @include button($backround-grey-aigm, $text-color-aigm);
    }
  }
  .btn-big {
    @include buttonBig($orange-aigm, $white-aigm);
  }
  .cadre {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    width: 100%;
    height: 62px;
    margin-bottom: 15px;
    border-radius: 7px;
    color: $black-aigm;
    background-color: $light-pink;
    box-shadow: 0px 1px 4px #56090f2b;
    p {
      font-weight: 500;
      letter-spacing: 0px;
      margin-left: 10px;
    }
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100% !important;
      a {
        cursor: pointer;
      }
    }
    .subtitle {
      background-color: $green-aigm;
      padding: 12px 21px;
      border-radius: 7px;
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      p {
        color: $white-aigm;
      }
    }
  }
}
</style>
